module.exports = __webpack_public_path__ + "img/angle-1.e85194d4.svg";